import http from './http';

const listInvoices = (page, websiteId) => {
  const websiteFilter = websiteId ? `&website=${encodeURIComponent(websiteId)}` : '';
  return http.get(`/website/stripe/invoices?page_size=10&page_nbr=${page}${websiteFilter}`);
};

const downloadInvoice = (websiteId, invoiceId) => {
  return http.getBlob(`/website/${websiteId}/stripe/invoice/${invoiceId}`);
};

// B0_59 : reçu de paiement (PDF relayé par l'API). Le PDF de facture Stripe reste
// « Montant dû » même une fois prélevé : c'est le reçu qui prouve le paiement.
const downloadReceipt = (websiteId, invoiceId) => {
  return http.getBlob(`/website/${websiteId}/stripe/invoice/${invoiceId}/receipt`);
};

export default {
  listInvoices,
  downloadInvoice,
  downloadReceipt
};

export { listInvoices, downloadInvoice, downloadReceipt };
